import ListSubheader from '@mui/material/ListSubheader'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import React from 'react'
import { countries } from '../../globalHeader/common/countries'

interface ICountrySelectProps {
    label: string
    value: string
    onChange: (value: string) => void
}

const CountrySelect: React.FC<ICountrySelectProps> = ({ label, value, onChange }) => (
    <TextField select label={label} value={value} onChange={(e) => onChange(e.target.value)} fullWidth>
        <MenuItem value="US">United States</MenuItem>
        <MenuItem value="CA">Canada</MenuItem>
        <MenuItem value="GB">United Kingdom</MenuItem>
        <ListSubheader
            sx={{
                borderBottom: '1px solid',
                borderColor: 'text.primary',
                my: 1,
            }}
        />
        {countries.map((c) => (
            <MenuItem key={c.code} value={c.code}>
                {c.name}
            </MenuItem>
        ))}
    </TextField>
)

export default CountrySelect
